import React from 'react';

import ChainapproachTeaser from './Teaser';
import ChainapproachFull from './Full';

const Campaign = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <ChainapproachTeaser {...props} />;
  }

  return <ChainapproachFull {...props} />;
};

export default Campaign;
